import * as React from 'react';

import { ProjectDiagramNavbar } from 'src/containers/ProjectDiagram/ProjectDiagramNavbar';
import { ProjectDiagramView } from 'src/containers/ProjectDiagram/ProjectDiagramView';
import { VoiceboxFooter } from 'src/containers/Voicebox/VoiceboxFooter';

export const ProjectDiagram: React.VFC = () => (
  <div className="sd-project-diagram">
    <ProjectDiagramNavbar />
    <ProjectDiagramView />
    <VoiceboxFooter />
  </div>
);
